/* urh-v15.js — small behaviours for the v15 sections. Every init is safe to run again,
   so sections added or edited in the theme editor work straight away. */
(function(){
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }

  /* announcement bar rotation */
  function initAnn(root){
    $$('[data-u15-ann]',root).forEach(function(a){
      if(a.__t) clearInterval(a.__t);
      var ms=$$('.m',a); if(ms.length<2) return;
      var i=0, sp=(parseInt(a.dataset.speed,10)||5)*1000;
      a.__t=setInterval(function(){ ms[i].classList.remove('on'); i=(i+1)%ms.length; ms[i].classList.add('on'); }, sp);
    });
  }

  /* footage: muted, looping, inline autoplay while on screen (also with reduced motion on, by request) */
  var vio = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ var v=e.target;
      if(e.isIntersecting){ if(!v.getAttribute('src') && v.dataset.src){ v.src=v.dataset.src; }
        v.muted=true; var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
      else { v.pause(); }
    });
  },{threshold:0.25}) : null;
  function initVideos(root){
    $$('video[data-u15-auto]',root).forEach(function(v){
      v.muted=true; v.setAttribute('muted',''); v.setAttribute('playsinline','');
      if(vio){ vio.observe(v); } else { if(v.dataset.src) v.src=v.dataset.src; v.play(); }
    });
  }

  /* size ladder: tap a size, show its note */
  function initLadder(root){
    $$('[data-u15-ladder]',root).forEach(function(l){
      if(l.__b) return; l.__b=true;
      l.addEventListener('click',function(e){ var b=e.target.closest('.rung'); if(!b) return;
        var k=b.dataset.k; $$('.rung',l).forEach(function(r){ r.setAttribute('aria-pressed', r===b); });
        var sec=l.closest('section')||document; $$('.lnote>div',sec).forEach(function(n){ n.classList.toggle('on', n.dataset.k===k); });
      });
    });
  }

  /* product page: variant pills, price, stock chip, button label, gallery thumbs, sticky bar */
  function money(c, fmt){ var v=(c/100); var s=(v%1===0)? v.toFixed(0) : v.toFixed(2); return (fmt||'${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s); }
  function initProduct(root){
    $$('[data-u15-product]',root).forEach(function(p){
      if(p.__b) return; p.__b=true;
      var dataEl=p.querySelector('script[data-u15-variants]'); if(!dataEl) return;
      var D; try{ D=JSON.parse(dataEl.textContent); }catch(e){ return; }
      var idIn=p.querySelector('input[name="id"]'), btns=$$('.sizes button',p), price=p.querySelector('[data-u15-price]'), stock=p.querySelector('[data-u15-stock]'),
          atcs=$$('[data-u15-atc]',p.closest('.u15')||document), lowT=D.low||10;
      function render(v){
        if(!v) return;
        if(idIn) idIn.value=v.id;
        btns.forEach(function(b){ b.setAttribute('aria-checked', String(+b.dataset.id===v.id)); });
        if(price) price.innerHTML=money(v.price,D.fmt)+(v.compare>v.price?' <s>'+money(v.compare,D.fmt)+'</s>':'');
        if(stock){
          if(!v.available){ stock.className='stock'; stock.innerHTML='<i></i>Sold out in '+v.title; }
          else if(D.showStock && v.tracked && v.qty>0){ stock.className=v.qty<=5?'stock':'stock ok'; stock.innerHTML='<i></i>'+v.qty+' left in '+v.title; }
          else { stock.className='stock ok'; stock.innerHTML='<i></i>In stock'; }
        }
        atcs.forEach(function(a){ a.disabled=!v.available; var lab=a.dataset.label||'Add to cart'; a.textContent=v.available?(lab+(a.dataset.price==='1'?' · '+money(v.price,D.fmt):'')):'Sold out'; });
        var ss=document.querySelector('[data-u15-sticky-sub]'); if(ss) ss.textContent=v.title+' · '+money(v.price,D.fmt);
        if(history.replaceState && D.url){ history.replaceState({},'',D.url+'?variant='+v.id); }
      }
      btns.forEach(function(b){ b.addEventListener('click',function(){ var v=D.variants.filter(function(x){return x.id===+b.dataset.id;})[0]; render(v); }); });
      var cur=D.variants.filter(function(x){return x.id===D.current;})[0]||D.variants[0]; render(cur);
    });
    $$('[data-u15-gallery]',root).forEach(function(g){
      if(g.__b) return; g.__b=true;
      var tr=g.querySelector('.gtrack'), th=g.querySelector('.thumbs'), cnt=g.querySelector('.gcount'); if(!tr) return;
      if(th) th.addEventListener('click',function(e){ var b=e.target.closest('button'); if(!b) return; tr.scrollTo({left:(+b.dataset.i)*tr.clientWidth,behavior:RM?'auto':'smooth'}); });
      var t; tr.addEventListener('scroll',function(){ clearTimeout(t); t=setTimeout(function(){ var i=Math.round(tr.scrollLeft/tr.clientWidth);
        if(th) $$('button',th).forEach(function(b,j){ b.setAttribute('aria-current', String(j===i)); });
        if(cnt) cnt.textContent=(i+1)+'/'+tr.children.length; },90); },{passive:true});
    });
    var st=document.querySelector('[data-u15-sticky]'), main=document.querySelector('[data-u15-atc-main]');
    if(st && main && 'IntersectionObserver' in window && !st.__b){ st.__b=true;
      new IntersectionObserver(function(es){ es.forEach(function(e){ st.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top<0); }); }).observe(main);
      var sb=st.querySelector('button'); if(sb) sb.addEventListener('click',function(){ var f=document.querySelector('[data-u15-product] form[action$="/cart/add"]'); if(f){ if(f.requestSubmit) f.requestSubmit(); else f.submit(); } });
    }
  }

  /* product recommendations (Shopify's own engine) */
  function initRecs(root){
    $$('[data-u15-recs]',root).forEach(function(el){
      if(el.__b) return; el.__b=true;
      fetch(el.dataset.url).then(function(r){ return r.text(); }).then(function(h){
        var d=document.createElement('div'); d.innerHTML=h; var n=d.querySelector('[data-u15-recs-result]');
        if(n && n.children.length){ el.innerHTML=''; el.appendChild(n); if(window.URHHolo) window.URHHolo.refresh(); }
        else if(el.dataset.empty==='hide'){ var s=el.closest('.u15'); if(s) s.style.display='none'; }
      }).catch(function(){});
    });
  }

  function initAll(root){ initAnn(root); initVideos(root); initLadder(root); initProduct(root); initRecs(root); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load',function(e){ initAll(e.target); if(window.URHHolo) window.URHHolo.refresh(); });
})();
